import axios from 'axios'

import { config, keys, platform_name } from "../../../config.env";
import { getStorage } from '../../../lib'

const ENDPOINT_DOMAIN = config.API_ENDPOINT
const MICROSERVICE_TOKEN = config.API_TOKEN

const baseUrl = ENDPOINT_DOMAIN + "/api/v1"

export const ApiDataImport = (method, params, body) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/import/import-health-data-v.1.0.0`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}

		if (method === 'POST') {
			config.method = 'POST'
		}

		if (method === 'PUT') {
			config.method = 'PUT'
		}

		if (method === 'DELETE') {
			config.method = 'DELETE'
		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


export const ApiImportHistory = (params, accessToken) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}




export const ApiClearHistory = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "delete",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiPutHistory = (body, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "put",
			data: body,
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}



export const ApiFindDataRecord = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}




export const ApiFindDropdown = (doc_source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/dropdown/${doc_source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiFindCheckList = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/data/findChecklist`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {

				if (res.data.status) {
					resolve(res.data.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}



export const ApiMyHealthDiseaseRisk = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/diseaseRisk/latest`,
			// url: baseUrl + `/analytics/summary/myHealth/diseaseRisk`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiMyHealthNCDs = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/ncds`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiMyHealthExamination = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/examination`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiDashboardOverview = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/overview`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiOverviewUser = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/user`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiOverviewUserTotal = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/user/total`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiDashboardAnalytics = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiDashboardAnalyticsV1 = (source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/analytics/v1/${source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiDashboardAnalyticsV2 = (source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/analytics/v2/${source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiAnalyticsGraph = (source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/analytics/graph/${source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiAnalyticsData = (source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/analytics/data/${source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


export const ApiDashboardAnalyticsV3 = (source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/analytics/v3/${source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiDashboardAnalyticsV4 = (source, params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/analytics/v4/${source}`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


export const ApiNCDsResult = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiNCDsDetail = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/historyDetail`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


export const ApiResultHistory = (params) => {
	return new Promise((resolve) => {
		let config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/v1/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}


		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


export const ApiDiseaseGraph = (compare, year, department_code, group_field, result) => {
	return new Promise((resolve) => {
		let url = baseUrl + `/analytics/health-summary-dashboard/compare-by-disease-group/graph?compare_by_disease=${compare}&year=${year}&department_code=${department_code}`
		if (group_field) {
			url += `&${group_field}=${result}`
		}

		let config = {
			method: "get",
			url: url,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},
		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiDiseaseDetail = (compare, year, department_code, page, group_field, result) => {
	return new Promise((resolve) => {
		let url = baseUrl + `/analytics/health-summary-dashboard/compare-by-disease-group/detail?compare_by_disease=${compare}&year=${year}&department_code=${department_code}&page=${page}`
		if (group_field) {
			url += `&${group_field}=${result}`
		}

		let config = {
			method: "get",
			url: url,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},
		}

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiExportExcel = (data) => {
	return new Promise((resolve) => {
		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: baseUrl + `/export/excel/analytics/health-summary-dashboard/compare-by-disease-group`,
			headers: {
				'Authorization': `Bearer ${getStorage(keys.access_token)}`,
				'platform': platform_name,
				'Content-Type': 'application/json'
			},
			data: data
		};

		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}